import React, { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import moment from "moment";

import useInvoices from "../../hooks/use-invoices";
import useFarms from "../../hooks/use-farms";
import useStrategicAccounts from "../../hooks/use-strategic-accounts";

import { Header } from "../header";
import UploadModal from "../../pages/main/UploadModal";

import css from "./main-layout.module.css";
import { Footer } from "../footer/footer";

const MainLayout = () => {
	const loc = useLocation();

	const [activePage, setActivePage] = useState(loc.pathname.slice(1) || "Dashboard");
	const [showUpload, setShowUpload] = useState(false);
  const [startDate, setStartDate] = useState(moment().startOf("year").toDate());
  const [endDate, setEndDate] = useState(moment().endOf("day").toDate());  
  const [selectedFarms, setSelectedFarms] = useState([]);
  
  const {strategicAccounts} = useStrategicAccounts();
  const { farms, farmsLoading } = useFarms();

  useEffect(() => {
    const page = loc.pathname.slice(1) || "Dashboard"
    setActivePage(page)
  }, [loc.pathname.slice(1)]);

  const {
		selectedInvoice,
		setShowInvoice,
		setSelectedInvoice,
		refetchInvoices,
  } = useInvoices({selectedFarms, startDate, endDate});
  
  useEffect(() => {
    if (startDate && endDate) {
      refetchInvoices();
    }
  }, [startDate, endDate, selectedFarms, refetchInvoices]);

	const toggleShowUpload = () => {
		setShowUpload(!showUpload);
	};

	const header = (
		<Header
			showUpload={showUpload}
			toggleShowUpload={toggleShowUpload}
			activePage={activePage}
			setActivePage={setActivePage}
		/>
	);

  const modals = (
    <UploadModal
      open={showUpload}
      setOpen={setShowUpload}
      refetchInvoices={refetchInvoices}
      farms={farms}
      farmsLoading={farmsLoading}
      strategicAccounts={strategicAccounts}
      setSelectedInvoice={setSelectedInvoice}
      setShowInvoice={setShowInvoice}
      selectedInvoice={selectedInvoice}
    />
  );

	return (
		<main id="main" className={css.main}>
			{header}

      {/* //todo we can pass farm, strat acct data here. Then in the child components we can use useOutletContext to access it. Note it is an array that needs to be accessed by index
        const [
          activePage, 
          setActivePage, 
          showUpload, 
          setShowUpload,
          strategicAccounts, 
          flattenStratAccounts, 
          farms, 
          foobar] = useOutletContext(); */}

      <Outlet context={[ activePage, setActivePage, showUpload, setShowUpload ]} />

      {modals}

      <Footer/>
		</main>
	);
};

export default MainLayout;
